import * as React from 'react'

import CircleIcon from '@mui/icons-material/Circle'
import { Typography } from '@mui/material'

import { ProductProductStockEnum } from '@/gen/ecom/models/Product'
import { useTranslations } from '@/hooks/useTranslations'

import type { ProductWebshopStatusEnumSchema } from '@/schemas/productWebshopStatusEnumSchema'

interface Props {
  // TODO: migrate to our types
  productStock?: ProductProductStockEnum | ProductWebshopStatusEnumSchema
}

export const ProductStock: React.FC<Props> = ({ productStock }) => {
  const { translate } = useTranslations()

  const stockStatusMap = {
    outOfStock: { translation: translate('product.outOfStock'), color: 'warning.main' },
    inStock: { translation: translate('product.inStock'), color: 'success.main' },
    specialStock: { translation: translate('product.specialStock'), color: 'success.main' },
    nonStockWithQuantity: { translation: translate('product.nonStockWithQuantity'), color: 'success.main' },
    dropShippingStock: { translation: translate('product.dropShippingStock'), color: 'success.main' },
    discontinued: { translation: translate('product.stockLevelMessage.discontinued'), color: 'error.main' },
  }

  const getStockLevelStatus = React.useMemo(() => {
    switch (productStock) {
      case ProductProductStockEnum.StockRegularWithoutQuantity:
        return stockStatusMap['outOfStock']
      case ProductProductStockEnum.StockRegularWithQuantity:
        return stockStatusMap['inStock']
      case ProductProductStockEnum.NonStockWithoutQuantity:
        return stockStatusMap['specialStock']
      case ProductProductStockEnum.NonStockWithQuantity:
        return stockStatusMap['nonStockWithQuantity']
      case ProductProductStockEnum.NonStockDirectWithQuantity:
        return stockStatusMap['dropShippingStock']
      default:
        return stockStatusMap['discontinued']
    }
  }, [productStock])

  return (
    <Typography data-testid={productStock} variant="h5" sx={{ display: 'flex', color: getStockLevelStatus.color }}>
      <CircleIcon
        sx={{
          height: '0.8rem',
          width: '0.8rem',
          mr: 0.8,
          mt: 0.4,
          color: getStockLevelStatus.color,
        }}
      />
      <span>{getStockLevelStatus.translation}</span>
    </Typography>
  )
}
